import { useTranslation } from "react-i18next";

const STEPS = [
  { id: "upload", hasChoices: false },
  { id: "train", hasChoices: true },
  { id: "predict", hasChoices: false },
] as const;

export function HowItWorks() {
  const { t } = useTranslation("landing");

  return (
    <section id="how" className="scroll-mt-24 relative border-t border-[#1B2622] bg-[#080C0D]">
      <div className="relative mx-auto max-w-[1320px] px-6 py-24 lg:px-10 lg:py-28">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,340px)_1fr] lg:gap-20">
          <header className="lg:sticky lg:top-28 lg:self-start">
            <h2 className="bp-display text-[34px] text-[#E2EDE7] sm:text-[44px]">
              {t("how.title")}
            </h2>
            <p className="mt-6 max-w-[34ch] text-[15px] leading-[1.7] text-[#788A82]">
              {t("how.subtitle")}
            </p>
          </header>

          <ol className="relative grid gap-5">
            <span
              aria-hidden
              className="pointer-events-none absolute left-[26px] top-6 hidden h-[calc(100%-48px)] w-px bg-gradient-to-b from-[#1B2622] via-[#4CD6C4]/30 to-[#1B2622] lg:block"
            />
            {STEPS.map((step, idx) => (
              <li
                key={step.id}
                className="bp-panel group relative grid grid-cols-1 gap-5 p-7 anim-fade-up sm:grid-cols-[52px_1fr]"
                style={{ animationDelay: `${160 + idx * 130}ms` }}
              >
                <span className="relative z-10 flex h-11 w-11 items-center justify-center border border-[#25332E] bg-[#070A0B] bp-mono text-[15px] font-semibold text-[#4CD6C4]">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <div>
                  <h3 className="bp-mono text-[17px] font-semibold uppercase tracking-[0.02em] text-[#E2EDE7]">
                    {t(`how.steps.${step.id}.title`)}
                  </h3>
                  <p className="mt-3 max-w-[62ch] text-[14.5px] leading-[1.75] text-[#8A9990]">
                    {t(`how.steps.${step.id}.body`)}
                  </p>
                  {step.hasChoices && (
                    <>
                      <p className="mt-5 mono-label text-[#4CD6C4]">
                        {t(`how.steps.${step.id}.choicesLabel`)}
                      </p>
                      <ul className="mt-3 grid gap-px overflow-hidden border border-[#1B2622] sm:grid-cols-2">
                        {(
                          t(`how.steps.${step.id}.choices`, {
                            returnObjects: true,
                          }) as string[]
                        ).map((choice) => (
                          <li
                            key={choice}
                            className="flex items-center gap-3 bg-[#070A0B] px-4 py-3 bp-mono text-[13px] text-[#CDDAD3]"
                          >
                            <span aria-hidden className="text-[#4CD6C4]">+</span>
                            {choice}
                          </li>
                        ))}
                      </ul>
                      <p className="mt-5 max-w-[62ch] text-[14.5px] leading-[1.75] text-[#8A9990]">
                        {t(`how.steps.${step.id}.bodyAfter`)}
                      </p>
                    </>
                  )}
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
